import styles from './Roles.module.css';
import { useEffect } from 'react';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography
} from '@material-ui/core';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useShopAPI } from 'pages/PhotoAdmin/SelectShop/hooks/useShopApi';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import ScopeSelector from 'components/PhotoAdminComponents/Settings/Roles/ScopeSelector/ScopeSelector';
import { useUserApi } from 'hooks/useUserApi';
import ConfirmDialog from 'components/common/ConfirmDialog/ConfirmDialog';
import UserSearch from 'components/PhotoAdminComponents/Settings/Roles/UserSearch/UserSearch';
import { Breadcrumbs, Container, CssBaseline, Grow, Zoom } from '@mui/material';
import { useTranslation } from 'react-i18next';
const Roles = (props) => {
  const { t } = useTranslation(); 
  const shopId = useSelector((state) => state.nonPersistedReducers?.shopSliceReducer?.shopId);

  const loggedUser = useSelector((state) => state.nonPersistedReducers.userSliceReducer.currentUser);

  const [maintainers, setMaintainers] = useState();

  const { getAllScopes, allScopes, putShop, getShop, shop } = useShopAPI();

  const { getCurrentUser, getAllUsers, allUsers } = useUserApi();

  const translateScopes = (scope) => {
    if (scope === 'MANAGE_ORDERS') {
      return t('roles.manageOrders');
    }
    if (scope === 'VIEW_ORDERS') {
      return t('roles.viewOrders');
    }
    if (scope === 'MANAGE_SHOP') {
      return t('roles.manageShop');
    }
    if (scope === 'VIEW_SHOP') {
      return t('roles.viewShop');
    }
    if (scope === 'MANAGE_PRODUCTS') {
      return t('roles.manageProducts');
    }
    if (scope === 'VIEW_PRODUCTS') {
      return t('roles.viewProducts');
    }
    if (scope === 'MANAGE_PRICING') {
      return t('roles.managePricing');
    }
    if (scope === 'VIEW_PRICING') {
      return t('roles.viewPricing');
    }
    if (scope === 'VIEW_PAYMENTS') {
      return t('roles.viewPayments');
    }
    if (scope === 'VIEW_INVOICES') {
      return t('roles.viewInvoices');
    }
    if (scope === 'VIEW_INVOICE_VENDORS') {
      return t('roles.viewInvoiceVendors');
    }
    if (scope === 'MANAGE_INVOICE_VENDORS') {
      return t('roles.manageInvoiceVendors');
    }
  };

  const [m, setM] = useState(null);

  const handleRefresh = () => {
    getCurrentUser();
    getShop();
  };

  const removeMaintainer = async (userId) => {
    setMaintainers(maintainers.filter((maintainer) => maintainer.user.id !== userId));
    const body = {
      ...shop,
      maintainers: shop.maintainers.filter((maintainer) => maintainer.user.id !== userId)
    };
    await putShop({ body: body });
    handleRefresh();
  };

  useEffect(() => {
    getAllScopes();
    if (shopId !== -1) {
      getShop();
    }
  }, [shopId]);

  useEffect(() => {
    setMaintainers(shop?.maintainers);
  }, [shop]);

  const [currentUser, setCurrentUser] = useState(null);
  const [currentScopes, setCurrentScopes] = useState(null);
  const [currentId, setCurrentId] = useState(null);
  const [loading, setLoading] = useState();

  const clearSelection = () => {
    setCurrentScopes(null);
    setCurrentUser(null);
    setCurrentId(null);
  };

  const handleUpdate = async () => {
    setLoading(true);
    await putShop({
      body: {
        ...shop,
        maintainers: maintainers
      }
    });
    setLoading(false);
    clearSelection();
    handleRefresh();
  };

  return (
    <Container maxWidth={false} className={styles.root}>
      <CssBaseline />
      <Breadcrumbs aria-label='breadcrumb' className={styles.breadcrumb}>
        <Typography style={{ fontFamily: 'var(--font-main)' }} variant='body1'>
          {t('roles.shopManagers')}
        </Typography>
      </Breadcrumbs>

      <Grow in={true}>
        <Container maxWidth className={styles.container}>
          {' '}
          <div className={styles.paper}>
            <UserSearch
              shop={shop}
              putShop={putShop}
              getAllUsers={getAllUsers}
              handleRefresh={handleRefresh}
              allUsers={allUsers}
              maintainers={maintainers}
            />

            <Table style={{ height: '70%', marginBottom: '0.4rem' }}>
              <TableHead
                style={{
                  background: 'var(--primary-background-secondary)'
                }}>
                <TableRow>
                  <TableCell width='5%' className={styles.hcell}>
                    #
                  </TableCell>
                  {/* <TableCell width="20%" className={classes.hcell}>
                    Azonosító
                  </TableCell> */}
                  <TableCell width='15%' className={styles.hcell}>
                    {t('roles.username')}
                  </TableCell>
                  <TableCell width='60%' colSpan={2} className={styles.hcell} style={{ maxWidth: '60px' }}>
                    {t('roles.roles')}
                  </TableCell>
                  <TableCell width='10%' className={styles.hcell}></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {maintainers &&
                  maintainers
                    ?.filter((user) => user.user.username !== 'system-agent')
                    ?.map(({ user, scopes, id }, idx) => (
                      <TableRow key={`maintainer_user_${user?.id}`}>
                        <TableCell width='5%' className={styles.bcell}>
                          {idx + 1}
                        </TableCell>

                        <TableCell width='15%' className={styles.bcell}>
                          {user?.username}
                        </TableCell>
                        <TableCell
                          width='60%'
                          colSpan={2}
                          className={styles.bcell}
                          style={{ overflow: 'hidden', maxWidth: '60px' }}>
                          {scopes?.map((scope) => translateScopes(scope))}
                        </TableCell>
                        <TableCell width='10%' className={styles.bcell}>
                          {loggedUser?.ownedShops[0]?.id !== shopId &&
                          !loggedUser?.maintainedShops
                            ?.find((shop) => shop.shop.id === shopId)
                            ?.scopes?.includes('MANAGE_SHOP') ? (
                            <Tooltip title={t('roles.justNormal')}>
                              <EditIcon
                                style={{
                                  marginRight: '1rem',
                                  color: 'lightgrey'
                                }}
                                className={styles.icon}
                                onClick={() => {}}
                              />
                            </Tooltip>
                          ) : (
                            <Tooltip title={t('roles.editRoles')}>
                              <EditIcon
                                style={{ marginRight: '1rem' }}
                                className={styles.icon}
                                color='primary'
                                onClick={() => {
                                  setCurrentUser(user);
                                  setCurrentScopes(scopes);
                                  setCurrentId(id);
                                }}
                              />
                            </Tooltip>
                          )}
                          {loggedUser?.ownedShops[0]?.id !== shopId &&
                          !loggedUser?.maintainedShops
                            ?.find((shop) => shop.shop.id === shopId)
                            ?.scopes?.includes('MANAGE_SHOP') ? (
                            <Tooltip title={t('roles.onlyManageShop')}>
                              <DeleteIcon style={{ color: 'lightgrey' }} className={styles.icon} onClick={() => {}} />
                            </Tooltip>
                          ) : (
                            <Tooltip title={t('roles.deleteUser')}>
                              <DeleteIcon color='error' className={styles.icon} onClick={() => setM(user)} />
                            </Tooltip>
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </div>
        </Container>
      </Grow>

      <ConfirmDialog
        open={m}
        onOk={() => {
          removeMaintainer(m?.id);
          setM(null);
        }}
        onClose={() => setM(null)}
        title={t('roles.sureDelete', { name: m?.username })}
        functionButtonColor={'var(--primary-success)'}
        functionButtonText={'Igen'}
        closeButtonText={'Nem'}
        multipleButtons
      />
      <Dialog open={currentUser} fullWidth maxWidth='lg'>
        <DialogTitle>
          <Typography variant='h4' color='primary'>
            {t('roles.manageRoles')}
          </Typography>
        </DialogTitle>
        {allScopes && (
          <DialogContent>
            <ScopeSelector
              currentUser={currentUser}
              setCurrentUser={setCurrentUser}
              currentScopes={currentScopes}
              setCurrentScopes={setCurrentScopes}
              maintainers={maintainers}
              setMaintainers={setMaintainers}
              allScopes={allScopes}
              currentId={currentId}
              shop={shop}
              putShop={putShop}
              handleRefresh={handleRefresh}
              handleTranslate={translateScopes}
            />
          </DialogContent>
        )}
        <DialogActions>
          <Button
            onClick={clearSelection}
            variant='contained'
            style={{
              backgroundColor: 'var(--primary-dark)',
              color: 'whitesmoke'
            }}>
            {t('common.cancel')}
          </Button>
          <Button onClick={handleUpdate} variant='contained' color='primary'>
            {loading ? (
              <CircularProgress size={24} style={{ color: 'var(--primary-text-primary)' }} />
            ) : (
              t('common.save')
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default Roles;
